import React from 'react';
import {TimelineLite} from 'gsap';
import _find from 'lodash/find';
import { ScrollToPlugin } from '../../../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin';
import {connect} from 'react-redux';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import Display from '../parts/display';
import { browserHistory, Link } from 'react-router';
import PortfolioBlock from '../portfolio/portfolioBlock';

class ServiceBlock extends React.Component {
    constructor() {
        super();
        this.state = {
            animated: false,
            id: null,
            name: "",
            slug: "",
            description: "",
            type: "",
            quote: {
                text: "",
                author: ""
            },
            quotes: [],
            activeQuoteNo: 0,
            portfolios: [],
            pageSlug: false,
            activeQuote: {
                quote: '',
                quoter: ''
            }
        };

        this.tl = new TimelineLite();
        this.quoteTimer = null;
        this.showDots = this.showDots.bind(this);
        this.updateQuotes = this.updateQuotes.bind(this);
    }
    updateState(){
        // let name = this.props.location.pathname.substring(9, this.props.location.pathname.length);
    }
    componentWillReceiveProps(nextProps){

        if(nextProps.site.selectedService !== this.props.site.selectedService){



            if(nextProps.site.selectedService.quotes){

                if(nextProps.site.selectedService.quotes.length > 0) {

                    this.setState({
                        quotes: nextProps.site.selectedService.quotes,
                        activeQuote: {
                            quote: '"' + nextProps.site.selectedService.quotes[0].quote + '"',
                            quoter: nextProps.site.selectedService.quotes[0].quoter,
                            logo: nextProps.site.selectedService.quotes[0].logo
                        }
                    }, ()=> {
                        if (this.quoteTimer) clearInterval(this.quoteTimer);
                        this.updateQuotes(1);
                    });

                }else{
                    this.setState({
                        quotes: [],
                        activeQuote: {
                            quote: '',
                            quoter: '',
                            logo:  ''
                        }
                    });
                }
            }
        }
        if(nextProps.site.services !== this.props.site.services){
            this.updateServices();
        }

        if(nextProps.site.selectedService !== this.props.site.selectedService){
            this.scrollToServices();
        }

    }
    scrollToServices(){
        this.tl.to(window, .6, {scrollTo: '#service'});
    }
    updateServices(){
        function getPosition(str, m, i) {
            return str.split(m, i).join(m).length;
        }

        if((this.props.location.pathname.match(/\//g) || []).length == 2){
            let name = this.props.location.pathname.substring(10, this.props.location.pathname.length);
            if(this.props.site.services.length > 0) this.props.actions.loadService(_find(this.props.site.services, {slug: name}));
        }else if((this.props.location.pathname.match(/\//g) || []).length == 3){
            let name = this.props.location.pathname.substring(10, getPosition(this.props.location.pathname, '/', 3));
            let name2 = this.props.location.pathname.substring(getPosition(this.props.location.pathname, '/', 3) + 1, this.props.location.pathname.length);
            this.props.actions.loadService(_find(this.props.site.services, {slug: name}));
            this.props.actions.selectPortfolio(name2);
            this.setState({
                pageSlug: name2
            });
        }
    }
    componentWillUnmount(){
        if(this.quoteTimer) clearInterval(this.quoteTimer);
    }
    componentDidMount(){
        function getPosition(str, m, i) {
            return str.split(m, i).join(m).length;
        }
        if(!this.props.site.selectedService){
            this.updateServices();
        }
        // window.scrollTo(0,0);

        // this.tl.to(window, .6, {scrollTo: '#service'});

        // this.updateQuotes();
    }
    updateQuotes(i){
        if(this.props.site.selectedService) {
            if(this.quoteTimer) clearInterval(this.quoteTimer);

            if(i){
                let i = i;
            }else{
                let i = 0;
            }

            let timer = () => {

                if(this.props.site.selectedService.quotes[i]){
                    this.setState({
                        activeQuoteNo: i,
                        activeQuote: {
                            quote: '"' + this.props.site.selectedService.quotes[i].quote + '"',
                            quoter: this.props.site.selectedService.quotes[i].quoter,
                            logo:  this.props.site.selectedService.quotes[i].logo
                        }
                    });
                }

                if(i >= this.props.site.selectedService.quotes.length - 1) {
                    i = 0
                }else{
                    i++;
                }
            };

            timer();

            this.quoteTimer = setInterval(()=> {
                timer();
            }, 5000);
        }
    }
    showDots(quote, i){
        return <span key={i} onClick={()=>this.updateQuotes(i)} className={this.state.activeQuoteNo == i? "dot active":"dot"}></span>;
    }
    showDescription(){
        return {__html: this.props.site.selectedService.description};
    }
    quote(){
        return <ReactCSSTransitionReplace transitionName="cross-fade"
                                          transitionEnterTimeout={300} transitionLeaveTimeout={300}>
        <div key={this.state.activeQuote.quoter} className="quote-slider"><blockquote dangerouslySetInnerHTML={{__html: this.state.activeQuote.quote}}></blockquote>
                <p>{this.state.activeQuote.quoter}</p>
            {this.state.activeQuote.logo? <img src={this.state.activeQuote.logo} className="quote-logo"/>: ''}
            <div className="dots">
                {this.state.quotes.map(this.showDots)}
            </div>
            </div>

            </ReactCSSTransitionReplace>
    }
    render() {
        return (
            <Display if={this.props.site.selectedService}>
                <div className="service-details" id="service">
                    <div className="services-block" ref="block">
                        <div className="container">
                            <div className="row">
                                <ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
                                    <h2 key={this.props.site.selectedService.name}>/ <span dangerouslySetInnerHTML={{__html: this.props.site.selectedService.name}} /></h2>
                                </ReactCSSTransitionReplace>

                                <div className="col-md-6 no">
                                    <ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
                                        <div key={this.props.site.selectedService.description} dangerouslySetInnerHTML={{__html: this.props.site.selectedService.description}} />
                                    </ReactCSSTransitionReplace>
                                </div>

                                <div className="col-md-6">
                                    {this.quote()}
                                </div>
                                {/*<div className="down-arrow"><i className="fa fa-angle-down"></i></div>*/}
                            </div>
                        </div>
                    </div>
                </div>
                <PortfolioBlock items={this.props.site.selectedPortfolios} title={true} pathname={this.props.location.pathname} pageSlug={this.state.pageSlug} services={true} page={this.props.params.id} children={this.props.children} />
            </Display>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        site: state.site
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceBlock);



/** WEBPACK FOOTER **
 ** ./src/js/components/services/serviceBlock.js
 **/